import apiClient from "./api";

export async function getProductReviews(productId) {
  try {
    const res = await apiClient.get(`/products/${productId}/reviews`);
    return { success: true, reviews: res.data || [] };
  } catch (error) {
    return {
      success: false,
      reviews: [],
      error: error?.response?.data?.detail || "Failed to load reviews",
    };
  }
}

/** Works logged in or out — backend returns read vs write permission. */
export async function getReviewEligibility(productId) {
  try {
    const res = await apiClient.get(`/products/${productId}/reviews/eligibility`);
    return { success: true, eligibility: res.data };
  } catch (error) {
    return {
      success: false,
      eligibility: {
        can_read: true,
        can_review: false,
        has_purchased: false,
        already_reviewed: false,
        message: "You can read reviews. Writing a review requires a verified purchase.",
      },
      error: error?.response?.data?.detail || "Failed to check review eligibility",
    };
  }
}

export async function submitProductReview(productId, { rating, title, comment, orderItemId, mediaIds }) {
  try {
    const res = await apiClient.post(`/products/${productId}/reviews`, {
      rating,
      title: title || undefined,
      comment: comment || undefined,
      // R5: which delivered order item this review is for + uploaded media ids.
      order_item_id: orderItemId || undefined,
      media_ids: mediaIds && mediaIds.length ? mediaIds : undefined,
    });
    return { success: true, review: res.data };
  } catch (error) {
    return {
      success: false,
      error: error?.response?.data?.detail || "Failed to submit review",
    };
  }
}
